module.exports = __webpack_public_path__ + "img/safety-bg-m.fd125d48.png";